import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HistoricoEscolar } from 'src/app/models/historicoEscolar';

@Injectable({
  providedIn: 'root'
})

export class BuscaService {

  baseURL = environment.url;
  headers = new HttpHeaders({
    'apikey': environment.apptoken
  });

  // DEBUG - PRD
  //baseURL = 'https://prd-system-yduqs-alunos.br-s1.cloudhub.io/api';
  //headers = new HttpHeaders({
  //  client_id: '62e5d535df544e73b7284cd218c97be5',
  //  client_secret: 'c4d2F44d94AB423789AEf94b7B8524b9'
  //});

  constructor(
    private http: HttpClient
  ) { }

  getHistorico(codHistoricoDigital: string, codAluno: string) {
    let parametros;

    if (codHistoricoDigital) {
      parametros = { codHistoricoDigital: codHistoricoDigital };
    } else if (codAluno) {
      parametros = { codAluno: codAluno };
    }

    return this.http.get<HistoricoEscolar[]>(`${this.baseURL}/historico-escolar`, {
      headers: this.headers,
      params: parametros,
      withCredentials: true
    });
  }

}
